//====================================================
//  Initialization Filter modal
//====================================================

function fn_parts_show_filter(){
	if ($('.js-filter-clear').length){
		$( ".filter-block .checkbox input" ).on('click', function(e){
			$( ".filter-block .checkbox input" ).each(function( index ) {
				if ($(this).is(':checked')){
					$('.js-filter-clear').addClass('active');
					return false;
				} else {
					$('.js-filter-clear').removeClass('active');
				}
			});
	    });
	}
}